// components/DynamicPopup.tsx
import React from 'react';
import Image from 'next/image'; // Ensure you have the correct import for Next.js Image component

interface DynamicPopupProps {
    message: string;
    buttonText: string;
    onClose: () => void;
}

const DynamicPopup: React.FC<DynamicPopupProps> = ({ message, buttonText, onClose }) => {
    const handleButtonClick = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg text-center">
                <div className="flex items-start justify-start mb-4">
                    <Image
                        className="w-6 h-6 text-yellow-500 mr-2 mt-[-1px]"
                        src='/alert.svg'
                        alt="info1"
                        width={24}
                        height={24}
                    />
                    <p className="text-gray-700 text-left">{message}</p>
                </div>
                <button
                    onClick={handleButtonClick}
                    className="bg-orange-500 text-white py-2 px-4 rounded-full hover:bg-orange-600 focus:outline-none"
                >
                    {buttonText}
                </button>
            </div>
        </div>

    );
};

export default DynamicPopup;
